<script setup>
import {computed, defineProps, defineEmits} from 'vue';
import {
    utcToDate,
    dateToUtcISOString,
} from '@/assets/js/time';

const props = defineProps({
    modelValue: {
        type: [String, Array, null],
        default: null, // UTC ISO string or array of UTC ISO strings
    },
    type: {
        type: String,
        default: 'datetime',
    },
});

const emit = defineEmits(['update:modelValue']);

const isRange = computed(() => {
    return props.type?.includes('range');
});

const innerValue = computed({
    get() {
        if (isRange.value) {
            if (Array.isArray(props.modelValue)) {
                return props.modelValue.map(v => utcToDate(v));
            }
            return null;
        }
        return utcToDate(props.modelValue);
    },
    set(val) {
        if (isRange.value && Array.isArray(val)) {
            emit('update:modelValue', val.map(v => dateToUtcISOString(v)));
        } else {
            emit('update:modelValue', dateToUtcISOString(val));
        }
    },
});
</script>

<template>
    <el-date-picker
        v-model="innerValue"
        :type="type"
        v-bind="$attrs" />
</template>
